import React, { useState } from 'react';
import { FaTwitter, FaLinkedin } from 'react-icons/fa';
import {
	TwitterTimelineEmbed,
	TwitterShareButton,
	TwitterFollowButton,
	TwitterHashtagButton,
	TwitterMentionButton,
	TwitterTweetEmbed,
	TwitterMomentShare,
	TwitterDMButton,
	TwitterVideoEmbed,
	TwitterOnAirButton,
} from 'react-twitter-embed';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';

const propTypes = {
	...SectionProps.types,
};

const defaultProps = {
	...SectionProps.defaults,
};

const Hero = ({
	className,
	topOuterDivider,
	bottomOuterDivider,
	topDivider,
	bottomDivider,
	hasBgColor,
	invertColor,
	...props
}) => {
	const [videoModalActive, setVideomodalactive] = useState(false);

	const openModal = (e) => {
		e.preventDefault();
		setVideomodalactive(true);
	};

	const closeModal = (e) => {
		e.preventDefault();
		setVideomodalactive(false);
	};

	const outerClasses = classNames(
		'hero section center-content',
		topOuterDivider && 'has-top-divider',
		bottomOuterDivider && 'has-bottom-divider',
		hasBgColor && 'has-bg-color',
		invertColor && 'invert-color',
		className
	);

	const innerClasses = classNames(
		'hero-inner section-inner',
		topDivider && 'has-top-divider',
		bottomDivider && 'has-bottom-divider'
	);

	return (
		<section {...props} className={outerClasses}>
			<div className='container-sm'>
				<div className={innerClasses}>
					<div className='hero-content'>
						<h2
							align='justify'
							className='mt-0 mb-16 reveal-from-bottom'
							data-reveal-delay='200'
						>
							<br />
							<p class='blocktext'>
								<span role='img' aria-label='waving brown hand emoji'>
									👋🏽
								</span>{' '}
								Hamza<br></br>
								<span role='img' aria-label='a red pushpin emoji'>
									📌
								</span>{' '}
								NYC<br></br>
								<span role='img' aria-label='brown man coding'>
									👨🏽‍💻
								</span>{' '}
								Twitter
							</p>
						</h2>

						<TwitterFollowButton
							screenName={'oihamza'}
							options={{ size: 'large' }}
						/>

						{/* <h1
							className='mt-0 mb-16 reveal-from-bottom'
							data-reveal-delay='200'
						>
							Landing template for{' '}
							<span className='text-color-primary'>startups</span>
						</h1> */}
						<div className='container-xs'>
							{/* <p
								className='m-0 mb-32 reveal-from-bottom'
								data-reveal-delay='400'
							>
								Our landing page template works on all devices, so you only have
								to set it up once, and get beautiful results forever.
							</p> */}
							<div className='reveal-from-bottom' data-reveal-delay='600'>
								{/* <ButtonGroup>
									<Button
										tag='a'
										color='secondary'
										wideMobile
										href='https://twitter.com/oihamza/'
										target='_blank'
									>
										<FaTwitter
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
											alt='Follow me on Twitter'
											cursor='pointer'
										/>
									</Button>
									<Button
										tag='a'
										// style={{ color: 'black' }}
										color='secondary'
										wideMobile
										href='https://www.linkedin.com/in/oihamza/'
										target='_blank'
									>
										<FaLinkedin
											style={{
												fill: 'white',
												height: '2em',
												width: '2em',
											}}
											// attr={{ title: 'name' }}
											alt='Connect on LinkedIn'
											tag='a'
											href='https://www.linkedin.com/in/oihamza/'
											target='_blank'
											cursor='pointer'
										/>
									</Button>
								</ButtonGroup> */}
							</div>
						</div>
					</div>

					<div
						className='hero-figure reveal-from-bottom illustration-element-01'
						data-reveal-value='20px'
						data-reveal-delay='800'
					>
						{/* <a
							data-video='https://player.vimeo.com/video/174002812'
							href='#0'
							aria-controls='video-modal'
							onClick={openModal}
						> */}
						<Image
							className='has-shadow'
							src={require('./../../assets/images/hamza-mahal-round-lossy.png')}
							alt='Hero'
							width={896}
							height={504}
						/>
						{/* </a> */}
					</div>
					{/* <Modal
						id='video-modal'
						show={videoModalActive}
						handleClose={closeModal}
						video='https://player.vimeo.com/video/174002812'
						videoTag='iframe'
					/> */}
				</div>
			</div>
		</section>
	);
};

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;
